// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const FigmaDownloadFilledIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const ink = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M15.26 22.2503H8.73998C3.82998 22.2503 1.72998 20.1503 1.72998 15.2403V15.1103C1.72998 10.6703 3.47998 8.53027 7.39998 8.16027C7.79998 8.13027 8.17998 8.43027 8.21998 8.84027C8.25998 9.25027 7.95998 9.62027 7.53998 9.66027C4.39998 9.95027 3.22998 11.4303 3.22998 15.1203V15.2503C3.22998 19.3203 4.66998 20.7603 8.73998 20.7603H15.26C19.33 20.7603 20.77 19.3203 20.77 15.2503V15.1203C20.77 11.4103 19.58 9.93027 16.38 9.66027C15.97 9.62027 15.66 9.26027 15.7 8.85027C15.74 8.44027 16.09 8.13027 16.51 8.17027C20.49 8.51027 22.27 10.6603 22.27 15.1303V15.2603C22.27 20.1503 20.17 22.2503 15.26 22.2503Z"
        fill={ink}
      />
      <path
        d="M12 15.63C11.59 15.63 11.25 15.29 11.25 14.88V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V14.88C12.75 15.3 12.41 15.63 12 15.63Z"
        fill={ink}
      />
      <path
        d="M12.0001 16.7498C11.8101 16.7498 11.6201 16.6798 11.4701 16.5298L8.12009 13.1798C7.83009 12.8898 7.83009 12.4098 8.12009 12.1198C8.41009 11.8298 8.89009 11.8298 9.18009 12.1198L12.0001 14.9398L14.8201 12.1198C15.1101 11.8298 15.5901 11.8298 15.8801 12.1198C16.1701 12.4098 16.1701 12.8898 15.8801 13.1798L12.5301 16.5298C12.3801 16.6798 12.1901 16.7498 12.0001 16.7498Z"
        fill={ink}
      />
    </svg>
  );
};

export { FigmaDownloadFilledIcon };
